import { useTheme } from "next-themes";
import Image from "next/image";
import Link from "next/link";
import BlackLogo from "../../public/logo/black.png";
import WhiteLogo from "../../public/logo/colored_white.png";
import DashboardWalletButton from "../wallet-btn/DashboardWalletButton";
import DarkMode from "../mode/DarkMode";

const MobileHeader = ({ onToggleSidebar, isSidebarOpen }) => {
  const { resolvedTheme } = useTheme();

  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-white dark:bg-jacarta-800 border-b border-jacarta-100 dark:border-jacarta-600 md:hidden">
      <div className="flex items-center justify-between px-4 py-3">
        {/* Menu Toggle Button */}
        <button
          onClick={onToggleSidebar}
          className="p-2 rounded-lg text-jacarta-500 hover:text-jacarta-700 hover:bg-jacarta-50 dark:text-jacarta-300 dark:hover:text-white dark:hover:bg-jacarta-600 transition-colors duration-200"
          aria-label="Toggle sidebar"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {isSidebarOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>

        {/* Logo */}
        <Link href="/" className="flex items-center">
          <Image
            src={resolvedTheme === "dark" ? WhiteLogo : BlackLogo}
            alt="Impactoverse"
            width={120}
            height={28}
            className="h-6 w-auto"
          />
        </Link>

        {/* Wallet Button */}
        <div className="flex items-center gap-2">
          <DarkMode />
          <DashboardWalletButton className="text-sm" compact={true} />
        </div>
      </div>
    </header>
  );
};

export default MobileHeader;
